// About Us — Tee PDP + Collection CRO injector (2026-06-30)
// Targets:
//   - 8 tee PDPs (explicit handle allow-list) -> bundle line, trust bullets, tier-aware spec block
//   - /collections/(t-shirts|oversized-tees|regular-fit-tees) -> uniform 4:5 cards + hover-freeze (CSS)
// BRAND NOTE: tees ARE tee-safe to state 100% cotton + gsm publicly. The Native
// "no cotton%/blend/gsm" guardrail applies to Native ONLY and is never applied here.
// This script never runs on Native/Elements/hoodie URLs (handle + collection allow-lists).
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  var path = location.pathname;

  var TEE_HANDLES = [
    'about-us-logo-t',
    'about-us-oversized-signature-logo-t-shirt',
    'about-us-oversized-about-us-word-logo-t-shirt',
    'about-us-the-next-chapter-oversized-t-shirt',
    'about-us-some-time-done-oversized-t-shirt',
    'about-us-your-journey-our-craft-loose-fit-t-shirt',
    'about-us-signature-logo-loose-fit-t-shirt',
    'about-us-not-just-a-label-oversized-t-shirt'
  ];
  var isTeePDP = /\/products\//i.test(path) && TEE_HANDLES.some(function (h) { return path.indexOf(h) !== -1; });
  var isTeeCollection = /\/collections\/(t-shirts|oversized-tees|regular-fit-tees)/i.test(path);
  if (!isTeePDP && !isTeeCollection) return;
  if (window.__auTeeCroLoaded) return;
  window.__auTeeCroLoaded = true;

  var BRAND_NAVY = '#131936';
  var FONT_BODY = "'Raleway', 'Helvetica Neue', sans-serif";
  var FONT_DISPLAY = "'Unbounded', 'Helvetica Neue', sans-serif";

  // ── Style injection (collection grid + PDP classes) ─────────────────────────
  var style = document.createElement('style');
  style.textContent = [
    'ul.product-grid slideshow-component{pointer-events:none!important;}',
    'ul.product-grid slideshow-component *{pointer-events:none!important;}',
    'ul.product-grid slideshow-slide.product-media-container~slideshow-slide.product-media-container{display:none!important;}',
    'ul.product-grid .card__media-second{display:none!important;}',
    'ul.product-grid slideshow-component [class*="track"]{transform:none!important;transition:none!important;}',
    'ul.product-grid slideshow-slide.product-media-container{display:block!important;aspect-ratio:4/5!important;overflow:hidden!important;}',
    'ul.product-grid slideshow-slide.product-media-container img{width:100%!important;height:100%!important;object-fit:cover!important;object-position:center top!important;}',
    '.au-bogo-line{font-family:' + FONT_BODY + ';font-size:14px;color:' + BRAND_NAVY + ';margin:10px 0 14px;line-height:1.5;}',
    '.au-bogo-line a{color:inherit;text-decoration:underline;text-underline-offset:2px;}',
    '.au-trust-list{list-style:none;padding:0;margin:0 0 18px;}',
    '.au-trust-list li{font-family:' + FONT_BODY + ';font-size:13px;color:rgba(19,25,54,0.72);padding:3px 0;line-height:1.5;}',
    '.au-trust-list a{color:inherit;text-decoration:underline;text-underline-offset:2px;}',
    '.au-tee-spec{padding:28px 0 8px;border-top:1px solid rgba(19,25,54,0.1);margin-top:28px;}',
    '.au-tee-spec__heading{font-family:' + FONT_DISPLAY + ';font-size:12px;font-weight:700;color:' + BRAND_NAVY + ';letter-spacing:0.06em;text-transform:uppercase;margin:0 0 18px;line-height:1.4;}',
    '.au-tee-spec__table{width:100%;border-collapse:collapse;}',
    '.au-tee-spec__table td{font-family:' + FONT_BODY + ';font-size:13px;color:' + BRAND_NAVY + ';padding:9px 0;border-bottom:1px solid rgba(19,25,54,0.08);line-height:1.5;vertical-align:top;}',
    '.au-tee-spec__table td:first-child{color:rgba(19,25,54,0.52);width:48%;padding-right:12px;}',
    '.au-bloom-pdp-removed{display:none !important;}'
  ].join('');
  document.head.appendChild(style);

  // ── DOM helpers ─────────────────────────────────────────────────────────────
  function qs(selectors){ for (var i=0;i<selectors.length;i++){ var el=document.querySelector(selectors[i]); if (el) return el; } return null; }
  function insertAfter(n,r){ if (r&&r.parentNode){ r.parentNode.insertBefore(n,r.nextSibling); return true; } return false; }
  function insertBefore(n,r){ if (r&&r.parentNode){ r.parentNode.insertBefore(n,r); return true; } return false; }

  // ── Fabric-tier detection ────────────────────────────────────────────────────
  function detectTier(){
    var descEl = qs(['.product__description','.product-single__description','[class*="product-description"]','.rte']);
    var txt = (descEl ? descEl.textContent : '') || '';
    if (/260\s*gsm/i.test(txt)) return '260';
    if (/180\s*gsm/i.test(txt)) return '180';
    if (/loose-fit/i.test(path)) return '180';
    return '260';
  }

  // ── PDP ──────────────────────────────────────────────────────────────────────
  function initPDP(){
    var is260 = detectTier() === '260';
    var gsm = is260 ? '260gsm' : '180gsm';
    var fit = is260 ? 'Oversized' : 'Loose / regular';
    var construction = is260 ? 'Heavyweight, structured' : 'Midweight, everyday drape';
    var sizeGuide = is260 ? '/pages/260-gsm-oversize-t-shirt-size-chart' : '/pages/180gsm-loose-fit-t-shirt-size-guide';

    var priceEl = qs(['product-price','span.regular-price','.product__price','.price__regular','.price-item--regular','[class*="product-price"]','.product-single__price','price-money','.price']);
    if (priceEl){
      var priceContainer = priceEl;
      var tag0 = priceContainer.tagName.toLowerCase();
      if (tag0 !== 'product-price' && tag0 !== 'div' && tag0 !== 'p' && tag0 !== 'section'){
        for (var depth=0; depth<4; depth++){
          var parent = priceContainer.parentElement;
          if (!parent) break;
          var tag = parent.tagName.toLowerCase();
          if (tag==='div'||tag==='p'||tag==='section'||tag==='form'||tag==='product-price') break;
          priceContainer = parent;
        }
      }
      var bogoEl = document.createElement('p');
      bogoEl.className = 'au-bogo-line';
      bogoEl.innerHTML = 'Every hoodie comes with your choice of tee. Worn together, checked out once. <a href="/collections/hoodies">Shop hoodies &rarr;</a>';
      insertAfter(bogoEl, priceContainer);
    }

    var atcBtn = qs(['button[name="add"]','.product-form__submit','[data-testid="Checkout-button"]','form[action*="/cart/add"] button[type="submit"]','.btn--add-to-cart']);
    if (atcBtn){
      var trustEl = document.createElement('ul');
      trustEl.className = 'au-trust-list';
      trustEl.innerHTML = [
        '<li>&#x2713; ' + gsm + ' 100% premium cotton</li>',
        '<li>&#x2713; Complimentary shipping Australia-wide</li>',
        '<li>&#x2713; 30-day returns, no questions</li>',
        '<li><a href="' + sizeGuide + '">Find your size &rarr;</a></li>'
      ].join('');
      var atcWrap = atcBtn.closest('.product-form__buttons, .product-form__cart, [class*="buy-buttons"]') || atcBtn;
      insertBefore(trustEl, atcWrap);
    }

    var specTarget = qs(['.product__description','.product-single__description','[class*="product-description"]','.rte']);
    if (specTarget){
      var specEl = document.createElement('div');
      specEl.className = 'au-tee-spec';
      var rows = [
        '<tr><td>Fabric weight</td><td>' + gsm + '</td></tr>',
        '<tr><td>Material</td><td>100% premium cotton</td></tr>',
        '<tr><td>Fit</td><td>' + fit + '</td></tr>',
        '<tr><td>Construction</td><td>' + construction + '</td></tr>',
        '<tr><td>Designed</td><td>Melbourne</td></tr>'
      ];
      if (is260) rows.push('<tr><td>Set</td><td>Pairs with any hoodie, checked out once</td></tr>');
      specEl.innerHTML = [
        '<h3 class="au-tee-spec__heading">Built heavier than the average tee. Here\'s the spec.</h3>',
        '<table class="au-tee-spec__table"><tbody>',
        rows.join(''),
        '</tbody></table>'
      ].join('');
      specTarget.appendChild(specEl);
    }

    ['[class*="bloom"]','[id*="bloom"]','[data-section-type*="bloom"]'].forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        var t = (el.textContent||'').toLowerCase();
        if (t.indexOf('coming soon')!==-1||t.indexOf('bloom range')!==-1||t.indexOf('bloom —')!==-1||t.indexOf('arriving')!==-1) el.classList.add('au-bloom-pdp-removed');
      });
    });
  }

  // Collection treatment is CSS-only (injected above). No extra JS needed.
  function init(){ if (isTeePDP) initPDP(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
